// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"223":"home-page","277":"cast","321":"movie-details","493":"movies-page","903":"not-found-page","912":"reviews"}[chunkId] || chunkId) + "." + {"223":"c520342c","277":"e58a7a85","321":"f090dd12","493":"ce3a064a","774":"33434ce9","903":"dd538025","912":"4a1d0bdb"}[chunkId] + ".chunk.js";
};